/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, May 13th 2024, 3:22:02 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import CodeIcon from "@mui/icons-material/Code";
import { JSONConfigurationParams } from "common/components/JSONConfigurationParams";
import { FormField } from "lib/schemas";
import { StyledOSDialog } from "ui-widgets";
import { useOSFormContext } from "ui-widgets/forms/providers";

export const FieldCustomSettings = ({
  onClose,
  open,
}: Pick<React.ComponentProps<typeof StyledOSDialog>, "open" | "onClose">) => {
  const { watch, setValue } = useOSFormContext<FormField>();

  const watchedFieldLabel = watch("label");
  const watchedConfigurations = watch("extra_configurations");
  const customConfigurations = watchedConfigurations?.custom_settings || {};

  const onChangeCustomConfiguration: React.ComponentProps<
    typeof JSONConfigurationParams
  >["onChangeCustomConfiguration"] = (config) => {
    setValue("extra_configurations", { ...watchedConfigurations, custom_settings: config }, { shouldDirty: true });
  };

  return (
    <StyledOSDialog
      open={open}
      onClose={onClose}
      popUpIcon={<CodeIcon color="primary" />}
      popUpTitle={`Custom Settings for ${watchedFieldLabel}`}
    >
      <JSONConfigurationParams
        params={customConfigurations}
        onChangeCustomConfiguration={onChangeCustomConfiguration}
      />
    </StyledOSDialog>
  );
};
